import { t } from '@lingui/core/macro';
import { createFileRoute } from '@tanstack/react-router';

import type { CookieSettingsDecision } from '@/components/consent/cookie-settings-form';

import { notify } from '@/components/base/notifications/notifications';
import { CookieSettingsForm } from '@/components/consent/cookie-settings-form';
import { useConsent } from '@/lib/consent/use-consent';

import {
  SettingsSection,
  SettingsSectionSkeleton,
} from './-components/settings-section';
import { SETTINGS_HELP } from './-utils/help-articles';

export const Route = createFileRoute(
  '/researchers/_authenticated/settings/cookies',
)({
  component: CookiesPage,
  head: () => ({ meta: [{ title: t`Cookie settings` }] }),
});

function CookiesPage() {
  const { isResolved, answers, save } = useConsent();

  // Researchers have no participant profile to hold a durable copy, so, as in
  // legacy, the decision lives in the shared consent cookie alone.
  const onSave = async (decision: CookieSettingsDecision) => {
    save(decision, 'settings');
    notify({ title: t`Cookie settings saved`, color: 'success' });
    return true;
  };

  // Consent resolves in an effect; the form snapshots its defaults once.
  if (!isResolved) return <SettingsSectionSkeleton />;

  return (
    <SettingsSection
      helpUrl={SETTINGS_HELP.general}
      title={t`Cookie settings`}
      description={t`Your privacy is essential to us. Choose how cookies are used on our site.`}
    >
      <CookieSettingsForm answers={answers} onSave={onSave} showDeclineAll />
    </SettingsSection>
  );
}
